<template lang="html">
  <Editor
    id="editor"
    ref="editorSubmission"
    :init="editor_options"
    :value="content"
    @onInit="setInitialContent"
    @onKeyUp="changeContent"
    @onChange="changeContent"
    @onObjectResized="changeContent"
    @onExecCommand="changeContent"
  />
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import $ from 'jquery';
  import uploadFile from 'services/account/uploadFile';
  let editor;

  export default Vue.extend({
    components: {
      Editor: () => import('@tinymce/tinymce-vue'),
    },
    props: {
      savedContent: {
        type: String,
        default: '',
      },
      toolbarOptions: {
        type: String,
        default: null,
      },
      statusBar: {
        type: Boolean,
        default: true,
      },
      draftResponse: {
        type: String,
        default: '',
      },
      setFullscreen: {
        type: Boolean,
        default: false,
      },
      idEditor: {
        type: String,
        default: '#editor',
      },
    },
    watch: {
      draftResponse: function () {
        editor = window.tinymce.get('editor');
        if (editor)
          editor.setContent(this.savedContent || 'Write your response here');
      },
      setFullscreen: function () {
        if (this.setFullscreen) this.applyFullscreen(this.tinyEditor);
      },
    },
    data() {
      return {
        tinyEditor: undefined,
        content: null,
        interval: null,
        render_editor: false,
        editor_options: {
          selector: this.idEditor,
          height: '100%',
          license_key: 'gpl',
          paste_data_images: false,
          automatic_uploads: false,
          paste_block_drop: true,
          paste_block_img_drop: true,
          menubar: false,
          disabled: false,
          branding: false,
          placeholder: 'Write your response here',
          statusbar: false, /* this.statusBar */
          toolbar_items_size: 'small',
          emoticons_append: {
            custom_mind_explode: {
              keywords: ['brain', 'mind', 'explode', 'blown'],
              char: '🤯',
            },
          },
          plugins: 'link media autolink advlist lists lists code emoticons fullscreen table wordcount nonbreaking',
          nonbreaking_force_tab: true,
          noneditable_noneditable_class: 'mceNonEditable',
          block_formats: 'Body=p;Header 1=h2;Header 2=h3;',
          toolbar: 'fullscreen | undo redo | blocks | visualblocks | bold italic | alignleft aligncenter alignright | removeformat | bullist numlist | formatselect emoticons | link imageupload media | preview',
          skin_url: '/static/tinymce/tiny5skin/skins/ui/tiny5skin',
          default_link_target: '_blank',
          setup: this.setInitialConfigs,
          toolbar_mode: 'sliding',
        },
      };
    },
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getProfile',
        'getCurrentRT',
      ]),
    },
    mounted() {
      if (this.toolbarOptions) {
        this.editor_options.toolbar1 = this.toolbarOptions;
      }
      // SetTimeout Necessary to guarantee that tinymce is already in the dom
      /* setTimeout(() => {
        this.render_editor = true;
        window.addEventListener('resize', this.resetHeight);
      }); */
    },
    methods: {
      removeTags(o, tags) {
        tags.forEach((tag) => {
          o.content = o.content.replaceAll(`<${tag}>`, '');
          o.content = o.content.replaceAll(`</${tag}>`, '');
        });
      },
      applyFullscreen(tinyMCE) {
        tinyMCE.editorManager.activeEditor.execCommand('mceFullScreen');
        setTimeout(() => {
          this.$emit('unsetFullscreen');
        }, 10000);
      },
      setInitialConfigs(tinyMCE) {
        // NOTE: In this method we add buttons and any other config
        // to run on tinyMCE on the inner setup function

        // Checks if element is pink and if it is, select the node and make it black
        // We use this to easily select placeholders inside the templates
        this.tinyEditor = tinyMCE;
        tinyMCE.on('Click', () => {
          const element = editor.selection.getNode();
          if (element.classList.contains('pink-selectable')) {
            element.classList.remove('pink-selectable');
            editor.selection.select(element);
            editor.undoManager.add();
          }
        });

        //  Get the image sent by the user then save it to Amazon and append it
        const imageUploader = $(
          '<input id="tinymce-uploader" type="file" name="pic" accept="image/*" style="display:none">'
        );

        const fileUploader = $(
          '<input id="tinymce-uploader-2" type="file" name="file" accept=".pdf, .xls, .xlsx, .doc, .docx, .txt, .ppt, .pptx" style="display:none">'
        );

        $(tinyMCE.getElement()).parent().append(imageUploader);
        $(tinyMCE.getElement()).parent().append(fileUploader);

        imageUploader.on('change', () => {
          const input = imageUploader.get(0);
          const files = input.files;
          this.validateImageUpload(files, tinyMCE, imageUploader);
        });

        fileUploader.on('change', () => {
          const input = fileUploader.get(0);
          const files = input.files;
          this.validateFileUpload(files, tinyMCE, fileUploader);
        });

        tinyMCE.ui.registry.addButton('imageupload', {
          icon: 'image',
          tooltip: 'Insert/edit image',
          onAction: () => {
            imageUploader.trigger('click');
          },
        });
        tinyMCE.ui.registry.addButton('fileupload', {
          icon: 'upload',
          tooltip: 'Insert/edit file',
          onAction: () => {
            fileUploader.trigger('click');
          },
        });

        // Add RoundTable templates if the user is a teacher
        if (
          this.hasTeacherPermissionsInCourse ||
          this.getProfile.role === 'admin'
        ) {
          tinyMCE.ui.registry.addMenuButton('templates', {
            icon: 'paste-text',
            text: 'RoundTable Templates',
            fetch: (callback) => {
              var items = [];
              this.list_of_templates.forEach((el, index) => {
                items.push({
                  text: `${index + 1} - ${el.title}`,
                  type: 'menuitem',
                  onAction: () => this.confirmAddTemplate(el.prompt),
                });
              });
              callback(items);
            },
          });
        }
      },
      validateImageUpload(files, tinyMCE, imageUploader) {
        if (files[0].size > 5000000) {
          EventBus.$emit('toast-msg', 'Invalid file size. (Max. 5MB)');
          return;
        }
        if (!files[0].type.includes('image/')) {
          EventBus.$emit('toast-msg', 'Invalid file. (Only images accepted)');
          return;
        }
        this.uploadFile(files, tinyMCE, imageUploader);
      },
      validateFileUpload(files, tinyMCE, fileUploader) {
        if (files[0].size > 5000000) {
          EventBus.$emit('toast-msg', 'Invalid file size. (Max. 5MB)');
          return;
        }
        this.uploadTextFile(files, tinyMCE, fileUploader);
      },
      uploadFile(filesToUpload, tinyMCE, imageUploader) {
        tinyMCE.editorManager.activeEditor.setProgressState(true);
        uploadFile(filesToUpload).then((res) => {
          const location = res.data.aws_url;
          const fr = new FileReader();
          fr.onload = () => {
            const img = new Image();
            img.src = fr.result;
            tinyMCE.insertContent(`<img src="${location}"/>`);
            imageUploader.val('');
            tinyMCE.editorManager.activeEditor.setProgressState(false);
          };
          fr.readAsDataURL(filesToUpload[0]);
        });
      },
      uploadTextFile(filesToUpload, tinyMCE, fileUploader) {
        tinyMCE.editorManager.activeEditor.setProgressState(true);
        uploadFile(filesToUpload).then((res) => {
          const location = res.data.aws_url;
          const file_name = res.data.name;
          const fr = new FileReader();
          fr.onload = () => {
            tinyMCE.insertContent(`
               <div class="mceNonEditable" style="background-color:#dfe8f2; padding:5px; padding-right:25px; display:table">
            <img src="/static/online_roundtable_icons/attach_file_icon.svg" alt=""  />
            <a class="mceNonEditable" style="text-decoration: none" href="${location}" target="_blank">
              <span class="mceNonEditable" style="color:#3B24E3; font-size:18px; font-weight:bold" >${file_name}</button>
            </a>
            </div>`);
            tinyMCE.editorManager.activeEditor.setProgressState(false);
            fileUploader.val('');
          };
          fr.readAsDataURL(filesToUpload[0]);
        });
      },
      setInitialContent() {
        editor = window.tinymce.get('editor');
        editor.getBody().style.backgroundColor = '#FFFFFF';
        editor.setContent(this.savedContent || '');
        this.resetHeight();

        if (editor && editor.plugins && editor.plugins.wordcount) {
          this.$emit('editor', editor);
        }

        /*    editor.on('focus', () => {
          var content = editor.getContent();
          if (content === '<p>Write your response here</p>') {
            editor.setContent('');
          }
        });
        editor.on('click', () => {
          var content = editor.getContent();
          if (content === '<p>Write your response here</p>') {
            editor.setContent('');
          }
        });
        editor.on('focusout', () => {
          var content = editor.getContent();
          if (content === '') {
            editor.setContent('Write your response here');
          }
        });
        editor.on('focusin', () => {
          var content = editor.getContent();
          if (content === '<p>Write your response here</p>') {
            editor.setContent('');
          }
        });*/
      },
      resetHeight() {
        if (editor && editor.editorContainer) {
          const parentHeight = editor.editorContainer.parentNode.clientHeight;
          editor.editorContainer.style.height = parentHeight;
        }
      },
      changeContent() {
        const newContent = editor.getContent();
        if (this.content !== newContent) {
          this.content = newContent;
          this.$emit('change', this.content);
        }
      },
      confirmAddTemplate(template) {
        const confirmed = confirm(
          'Are you sure? This will overwrite your prompt'
        );
        if (confirmed) {
          editor.setContent('');
          editor.insertContent(template);
          editor.getBody().firstChild.scrollIntoView();
        }
      },
    },
  });
</script>
<!-- <style scoped lang="stylus">
  .emoji-container
    tbody
      height: 150px !important
      max-height: 150px
      overflow: scroll

  .mce-btn.mce-active
    background-color: pl-primary !important
    border-color: pl-primary !important
    button
      i
        color: #fff !important
        text-shadow: none

  .mce-container-body.mce-flow-layout
    text-align: center
    padding-bottom: 14px

  .tox
    .tox-tinymce
      border-width: none !important;
      box-shadow: none !important;
      border: none !important;

  .mce-path
    visibility: hidden !important

  .tox-toolbar-overlord

  .tox-tbtn
    width:auto !important
    height auto !important
    margin-right: 2px !important
    margin-left: 2px !important
    .tox-tbtn--enabled
      background-color: pl-primary !important
      border-color: pl-primary !important
      button
        i
          color: #fff !important
          text-shadow: none
  .tox
    .tox-tbtn--enabled
      background-color: pl-primary !important
      border-color: pl-primary !important
      button
        i
          color: #fff !important
          text-shadow: none

  .table-emoji
    font-size: 22px !important
    cursor: pointer
    &:hover
      cursor: pointer

  .tox-tinymce
    width: 100%
</style> -->


// WEBPACK FOOTER //
// tinymce.vue?02621087